const validationResults = ['FULL_MATCH', 'PARTIAL_MATCH', 'NO_MATCH', 'NO_DATA'] as const;
type ValidationResult = typeof validationResults[number];

export const validationResultValueFormatter = (value: ValidationResult) => {
  switch (value) {
    case 'FULL_MATCH':
      return 'Full match';
    case 'PARTIAL_MATCH':
      return 'Partial match';
    case 'NO_MATCH':
      return 'No match';
    case 'NO_DATA':
      return 'No data';
    default:
      return value;
  }
};
